import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  CommonService,
  PlantServiceService,
  SiteService
} from 'src/app/services/index';
import { AlertService, Constants } from 'src/app/shared';

@Component({
  selector: 'app-add-meter',
  templateUrl: './add-meter.component.html',
  styleUrls: ['./add-meter.component.scss']
})
export class AddMeterComponent implements OnInit {
  addMeterForm: UntypedFormGroup;
  MeterDetails: any;
  sites: any;
  AvailableDCU: any;
  CONST_Harmonic = 'Harmonic';
  CONST_lessThan33kV = Constants.SYSTEM_VOLTAGE.lessThan33kV;
  selectedSystemV: any;
  ChooseMeterRole: any;
  kpiUtility: string;
  configuredKpiUtilities: string[];
  ChooseMeterType = [{ meterType: 'SinglePhase' }, { meterType: 'ThreePhase' }];
  systemVoltages = [
    // not use 765, 400, 220 at the moment, may be enabled in future
    // Constants.SYSTEM_VOLTAGE.kV_765,
    // Constants.SYSTEM_VOLTAGE.kV_400,
    // Constants.SYSTEM_VOLTAGE.kV_220,
    Constants.SYSTEM_VOLTAGE.kV_132,
    Constants.SYSTEM_VOLTAGE.kV_110,
    Constants.SYSTEM_VOLTAGE.kV_66,
    Constants.SYSTEM_VOLTAGE.kV_33,
    Constants.SYSTEM_VOLTAGE.lessThan33kV
  ];

  constructor(
    private fb: UntypedFormBuilder,
    private siteService: SiteService,
    private alertService: AlertService,
    private plantService: PlantServiceService,
    private commonService: CommonService
  ) {
    this.resetMeter();
  }

  ngOnInit() {
    this.addMeterForm = this.fb.group({
      siteCtr: ['', [Validators.required]],
      kpiUtilityCtr: ['', [Validators.required]],
      dcuCtr: ['', [Validators.required]],
      meterMakeCtr: [''],
      meterTypeCtr: [''],
      serialNumberCtr: [''],
      meterRoleCtr: ['', [Validators.required]],
      insiteMeteridCtr: ['', [Validators.required]],
      currentUnbalanceXCtr: [''],
      meterIdCtr: [''],
      currentUnbalanceYCtr: [''],
      toIncludeCtr: [''],
      selectedSystemVCtr: [''],
      systemVCtr: [''],
      neutralILimitCtr: [''],
      maxPLimitCtr: [''],
      harmonicPowerLossLimitCtr: [''],
      divcurrentUnbalanceYCtr: [''],
      hardwareVersionCtr: ['']
    });
    this.siteService.getAllSites().subscribe((data) => {
      this.sites = data;
    });
  }

  resetMeter() {
    this.MeterDetails = {
      meterMake: '',
      meterType: '',
      serialNumber: '',
      meterRole: '',
      insiteMeterid: '',
      meterId: '',
      submitted: Constants.BOOLEAN_FALSE,
      DuplicateEntryErrorMessage: Constants.BOOLEAN_FALSE,
      EntryFailureMessage: Constants.BOOLEAN_FALSE,
      dcuId: '',
      siteId: '',
      toInclude: true,
      hardwareVersion: ''
    };
  }
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.addMeterForm.get(fieldName).hasError(errorCode);
  };

  /**
   * Function to trigger on selection of kpiUtility and fetching Meter Roles
   *
   * @param {*} event
   * @memberof AddMeterComponent
   */
  onUtilityChange(event) {
    this.kpiUtility = event.value;
    this.siteService
      .getMeterRolesBasedOnkpiUtility(this.kpiUtility)
      .subscribe((data) => {
        this.ChooseMeterRole = data.MeterRoles;
      });
  }

  SiteChange() {
    this.plantService
      .getSiteDetail(this.MeterDetails.siteId)
      .subscribe((data) => {
        if (!this.commonService.isNullOrUndefined(data)) {
          // this.configuredKpiUtilities = ['Energy', 'Water', 'Gas'];
          this.configuredKpiUtilities = data.configuredKpiUtilities;
        }
      });
    this.siteService
      .getAllDCUBySiteId(this.MeterDetails.siteId)
      .subscribe((data) => {
        this.AvailableDCU = data;
      });
    this.onMeterIDFocusOut();
    this.onInsiteMeterIDFocusOut();
  }

  DCUChange() {
    this.onInsiteMeterIDFocusOut();
  }

  changeMeterRole() {
    if (this.MeterDetails.meterRole !== this.CONST_Harmonic) {
      this.MeterDetails.currentUnbalanceX = undefined;
      this.MeterDetails.currentUnbalanceY = undefined;
      this.selectedSystemV = undefined;
      this.MeterDetails.systemV = undefined;
      this.MeterDetails.neutralILimit = undefined;
      this.MeterDetails.maxPLimit = undefined;
      this.MeterDetails.harmonicPowerLossLimit = undefined;
    }
  }
  selectSystemV() {
    if (this.selectedSystemV !== Constants.SYSTEM_VOLTAGE.lessThan33kV) {
      this.MeterDetails.systemV = this.selectedSystemV;
    } else {
      this.MeterDetails.systemV = undefined;
    }
  }
  submitMeterDetails() {
    const meter = {
      meterMake: this.MeterDetails.meterMake,
      meterType: this.MeterDetails.meterType,
      serialNumber: this.MeterDetails.serialNumber,
      meterRole: this.MeterDetails.meterRole,
      insiteMeterid: this.MeterDetails.insiteMeterid,
      meterId: this.MeterDetails.meterId,
      currentUnbalanceX: Number(this.MeterDetails.currentUnbalanceX),
      currentUnbalanceY: Number(this.MeterDetails.currentUnbalanceY),
      systemV: Number(this.MeterDetails.systemV),
      neutralILimit: Number(this.MeterDetails.neutralILimit),
      maxPLimit: Number(this.MeterDetails.maxPLimit),
      harmonicPowerLossLimit: Number(this.MeterDetails.harmonicPowerLossLimit),
      kpiUtility: this.MeterDetails.kpiUtility,
      dcuId: this.MeterDetails.dcuId,
      siteId: this.MeterDetails.siteId,
      toInclude: this.MeterDetails.toInclude,
      hardwareVersion: this.MeterDetails.hardwareVersion
      /*	//For Associated Flow Meter
        'hasFlowMeter':				this.hasFlowMeter,
        'flowMeterRole':            this.MeterDetails.flowMeterRole,
        'flowMeterMake':			this.MeterDetails.flowMeterMake,
        'flowMeterSerialNumber':	this.MeterDetails.flowMeterSerialNo,
        'flowMeterInsiteId' :       this.MeterDetails.flowMeterInsiteID,
        'flowMeterId' : 			this.MeterDetails.flowMeterID,	*/
    };
    this.siteService.insertMeter(meter).subscribe((data) => {
      if (data.response === 'Submitted') {
        this.MeterDetails.EntryFailureMessage = Constants.BOOLEAN_FALSE;
        this.MeterDetails.submitted = Constants.BOOLEAN_TRUE;
        this.alertService.showSuccess(Constants.MESSAGE.Save_success);
        setTimeout(() => {
          this.resetMeter();
        }, 10000);
      } else if (data.response === 'notSubmitted') {
        this.alertService.showError(Constants.MESSAGE.Save_failure);
        this.MeterDetails.EntryFailureMessage = Constants.BOOLEAN_TRUE;
      } else {
        console.log('unknown error occurred');
      }
    });
  }

  onMeterIDFocusOut() {
    const siteId = this.MeterDetails.siteId;
    const meterId = this.MeterDetails.meterId;
    if (siteId && siteId !== '' && meterId && meterId !== '') {
      this.siteService
        .checkUniqueMeterIdsOfSite(siteId, meterId)
        .subscribe((data: any) => {
          if (data) {
            console.log(data);
            if (data === 'Duplicate') {
              this.addMeterForm
                .get('meterIdCtr')
                .setErrors({ duplicated: true });
            } else {
              const error = this.addMeterForm
                .get('meterIdCtr')
                .getError('duplicated');
              if (error) {
                this.addMeterForm.get('meterIdCtr').setErrors(null);
              }
            }
          }
        });
    }
  }

  onInsiteMeterIDFocusOut() {
    const siteId = this.MeterDetails.siteId;
    const insiteMeterid = this.MeterDetails.insiteMeterid;
    const dcuId = this.MeterDetails.dcuId;
    if (
      siteId &&
      siteId !== '' &&
      insiteMeterid &&
      insiteMeterid !== '' &&
      dcuId &&
      dcuId !== ''
    ) {
      this.siteService
        .checkUniqueInsiteMetersOfDCU(siteId, dcuId, insiteMeterid)
        .subscribe((data: any) => {
          if (data) {
            console.log(data);
            if (data === 'Duplicate') {
              this.addMeterForm
                .get('insiteMeteridCtr')
                .setErrors({ duplicated: true });
            } else {
              const error = this.addMeterForm
                .get('insiteMeteridCtr')
                .getError('duplicated');
              if (error) {
                this.addMeterForm.get('insiteMeteridCtr').setErrors(null);
              }
            }
          }
        });
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
